import gql from 'graphql-tag';

export const relateSpacesToTenant = gql`
  mutation RelateSpaceToTenant($tenantId: UUID!, $propertyId: UUID!, $suitesToAdd: [String!]!, $suitesToRemove: [String!]!) {
    relateSpacesToTenant(tenantId: $tenantId, propertyId: $propertyId, suitesToAdd: $suitesToAdd, suitesToRemove: $suitesToRemove)
  }
`;
